import { render, staticRenderFns } from "./TipsSettings.vue?vue&type=template&id=5b95af28&scoped=true"
import script from "./TipsSettings.vue?vue&type=script&lang=js"
export * from "./TipsSettings.vue?vue&type=script&lang=js"
import style0 from "./TipsSettings.vue?vue&type=style&index=0&id=5b95af28&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b95af28",
  null
  
)

export default component.exports